import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchTenantBilling,
  setBilling as setAuthBilling,
} from "../../../store/authSlice";
import { normalizeRole } from "../../../utils/roles";
import { mediaUrl } from "../../../utils/clientHeroTheme";
import { HubScreen } from "./HubPwa";
import aa from "./adminApp.module.css";
import { Avatar } from "../../ui";
import {
  BillingSummaryCard,
  ROLE_LABEL,
  formatDateRu,
  formatRub,
} from "./staffProfileShared";

const MENU = [
  {
    id: "extended",
    label: "Расширенные настройки",
    hint: "Данные, подписка, уведомления, пароль",
    to: "/manage/app/profile/settings",
  },
  {
    id: "club",
    label: "Настройки клуба",
    hint: "Портал, брендинг, импорт",
    to: "/manage/app/settings",
  },
];

export default function AdminOwnerProfileHub() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { profile, role, tenant } = useSelector((state) => state.auth);
  const [billing, setBilling] = useState(null);

  const loadBilling = useCallback(async () => {
    try {
      const next = await dispatch(fetchTenantBilling()).unwrap();
      setBilling(next || null);
    } catch {
      setBilling(null);
      dispatch(setAuthBilling(null));
    }
  }, [dispatch]);

  useEffect(() => {
    loadBilling();
  }, [loadBilling]);

  const photoSrc = mediaUrl(profile?.photo_url);

  return (
    <HubScreen
      title="Профиль"
      onBack={() => navigate("/manage/app/more")}
      backLabel="Ещё"
    >
      <section className={aa.staffProfileHero}>
        <Avatar
          name={profile?.full_name || "?"}
          src={photoSrc}
          size="lg"
          className={aa.staffProfileHeroAvatar}
        />
        <div className={aa.staffProfileHeroText}>
          <h2 className={aa.staffProfileHeroName}>{profile?.full_name || "—"}</h2>
          <p className={aa.staffProfileHeroRole}>
            {ROLE_LABEL[normalizeRole(role)] || role}
          </p>
          <p className={aa.staffProfileHeroMeta}>{profile?.email}</p>
          {tenant?.name ? (
            <p className={aa.staffProfileHeroClub}>{tenant.name}</p>
          ) : null}
        </div>
      </section>

      {billing ? (
        <BillingSummaryCard
          billing={billing}
          formatRub={formatRub}
          formatDateRu={formatDateRu}
          onDetails={() => navigate("/manage/app/profile/settings")}
        />
      ) : null}

      <nav className={aa.staffProfileMenu} aria-label="Разделы профиля">
        {MENU.map((item) => (
          <button
            key={item.id}
            type="button"
            className={aa.staffProfileMenuItem}
            onClick={() => navigate(item.to)}
          >
            <span className={aa.staffProfileMenuText}>
              <strong>{item.label}</strong>
              <span>{item.hint}</span>
            </span>
            <span className={aa.staffProfileMenuChevron} aria-hidden />
          </button>
        ))}
      </nav>
    </HubScreen>
  );
}
